export default document.addEventListener('DOMContentLoaded', () => {
  const heroVideoEls = document.querySelectorAll('.hero-video');

  // Exit if no hero-videos exist
  if (!heroVideoEls) return;

  heroVideoEls.forEach((heroVideoEl, index) => {
    const buttonEl = heroVideoEl.querySelector('.hero-video__control');
    const buttonTextEl = buttonEl.querySelector('.hero-video__control-text');
    const videoEl = heroVideoEl.querySelector('.hero-video__video');
    const svgUseEl = buttonEl.querySelector('svg use');
    const spritePath = '/assets/images/icons.svg';

    heroVideoEl.setAttribute('id', `hero-video-${index}`);
    buttonEl.setAttribute('aria-controls', `hero-video-${index}`);

    // Attach event handler for pause / play
    buttonEl.addEventListener('click', () => {
      // Determine action of button
      if (videoEl.paused) {
        videoEl.play();
        svgUseEl.setAttribute('href', `${spritePath}#pause`);
      } else {
        videoEl.pause();
        svgUseEl.setAttribute('href', `${spritePath}#play`);
      }
      // Base aria-pressed on whether video is paused or not
      buttonTextEl.innerText = videoEl.paused ? 'Play' : 'Pause';
    });
  });
});
